import { combineReducers, createStore } from "redux";

// 로딩Bar 상태 StateReducer 시작
const initLoading = true;

const rdcLoading = (state = initLoading, action) => {
  switch (action.type) {
    case "loadingChange":
      state = action.payload;
      return state;
    default:
      return state;
  }
};
// 로딩Bar 상태 StateReducer 끝

// 유저정보 상태 StateReducer 시작
const initUserinfo = {
  comcode: null,
  comname: null,
  id: null,
  userid: null,
  username: null,
  usertype: null,
  userToken: null,
};

const reducerAuth = (state = initUserinfo, action) => {
  switch (action.type) {
    case "authUpdate":
      state = action.payload;
      return state;
    default:
      return state;
  }
};
// 유저정보 상태 StateReducer 끝

// 현재페이지정보 상태 StateReducer 시작
const initPage = "index";

const reducerPage = (state = initPage, action) => {
  switch (action.type) {
    case "pageChange":
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
// 현재페이지정보 상태 StateReducer 끝

//reducer 여러개 사용시 combineReducers로 합쳐서 obj형태로 저장함
let store = createStore(
  combineReducers({ rdcLoading, reducerAuth, reducerPage })
);

export { store };
